import { FC } from "react";
import { useGetCurrentUser } from "~/api/users/users";
import { Tour } from "../Tour";

interface CasePageTourProps {
  isReady: boolean;
}

export const CasePageTour: FC<CasePageTourProps> = ({ isReady }) => {
  const { data: user } = useGetCurrentUser();

  const shouldShowTour = user?.hasCompletedFtue && isReady;

  return <Tour tourId="casePage" enabled={shouldShowTour} />;
};
